// Core Imports
import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";

// Bootstrap Components
import { Container, Col, Row } from "react-bootstrap";

// Assets and Icons
import Logo from "../assets/images/logo/logo-light.png";
import { siteInfo } from "../data/siteData";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TwitterIcon from "@mui/icons-material/Twitter";
import RoomIcon from "@mui/icons-material/Room";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";

const Footer = () => {
  const { pathname } = useLocation();

  const [activePage, setActivePage] = useState({
    home: "",
    rmc: "",
    contact: "",
  });

  const currentYear = new Date().getFullYear();

  // Update active mobile footer menu tab based on path
  useEffect(() => {
    const path = pathname;

    setActivePage({
      home: path === "/" ? "active" : "",
      rmc: path === "/rmc" ? "active" : "",
      contact: path === "/contact" ? "active" : "",
    });

    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div id="footer">
      <Container>
        <Row className="justify-content-lg-between justify-content-center">
          {/* === Logo & Social Icons === */}
          <Col className="col-12 col-md-4 col-lg-3 text-center mb-4 mb-md-0">
            <img src={Logo} alt="Glazerocks RMC Logo" className="img-fluid mb-3" />
            <div className="social">
              <ul className="list-unstyled d-flex justify-content-center">
                <li className="mx-2"><Link to="#"><InstagramIcon /></Link></li>
                <li className="mx-2"><Link to="#"><FacebookIcon /></Link></li>
                <li className="mx-2"><Link to="#"><YouTubeIcon /></Link></li>
                <li className="mx-2"><Link to="#"><TwitterIcon /></Link></li>
              </ul>
            </div>
          </Col>

          {/* === Quick Links === */}
          <Col className="col-12 col-md-4 col-lg-2 mb-4 mb-md-0 px-xl-5">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li><h6><a href="/company">Company</a></h6></li>
              <li><h6><a href="/plants">Plants</a></h6></li>
              <li><h6><a href="/rmc">RMC</a></h6></li>
              <li><h6><a href="/contact">Contact Us</a></h6></li>
            </ul>
          </Col>

          {/* === Contact Information === */}
          <Col className="col-12 col-md-4 col-lg-3 px-xl-5">
            <h5>Contact Us</h5>
            <p><RoomIcon /> {siteInfo.address.split(",").slice(0,3).join(", ")}</p>
            <p><EmailIcon /> <a href={`mailto:${siteInfo.email}`}>{siteInfo.email}</a></p>
          </Col>

          {/* === Google Map Embed === */}
          <Col className="col-12 col-md-5 col-lg-3">
            <h5>Google Map</h5>
            <iframe
              title="RMC Map Location"
              src={siteInfo.mapEmbed}
              width="100%"
              height="150"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </Col>
        </Row>

        {/* === Divider Line === */}
        <hr />

        {/* === Footer Bottom Row === */}
        <Row>
          <Col md={8} className="copyright">
            <p>&copy; {currentYear} Glazerocks RMC. All rights reserved.</p>
          </Col>
          <Col md={4} className="copyright links text-md-end">
            <p>
              <a href="#">Privacy Policy</a> | <a href="#">Sitemap</a>
            </p>
          </Col>
        </Row>
      </Container>

      {/* === Mobile Sticky Footer Menu === */}
      <div className="d-block d-md-none menu-footer">
        <Row className="p-3">
          <Col className="b-right text-center">
            <Link to="/" className={activePage.home}>Home</Link>
          </Col>
          <Col className="b-right text-center">
            <Link to="/rmc" className={activePage.rmc}>RMC</Link>
          </Col>
          <Col className="text-center">
            <Link to="/contact" className={activePage.contact}>Contact Us</Link>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Footer;
